import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

const AdminRoute = ({ children }) => {
  // Example: assuming admin role is "999" (replace with your admin role code)
  const userToken = Cookies.get("authToken");
  const empRole = localStorage.getItem("empRole");

  const isAuthenticated = !!userToken;
  const isAdmin = empRole === "5"; // Change "999" to your actual admin role code

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  if (!isAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }
  return children;
};

export default AdminRoute;
